import { CashCount } from "../CashCount";
import { CashDetail } from "../CashDetail";
import { TransactionFlowEnum } from "../enums/TransactionFlowEnum";
import { TransactionSubtypeEnum } from "../enums/TransactionSubtypeEnum";
import { TransactionTypeEnum } from "../enums/TransactionTypeEnum";
import { TransactionDetail } from "../TransactionCategory";
import { Cheque } from "./Cheque";
import { IntegrationFeedback } from "./IntegrationFeedback";
import { MachineBag } from "./MachineBag";
import { Ticket } from "./Ticket";
import { TransactionEnvelopeInfo } from "./TransactionEnvelopeInfo";

export class Transaction {
    /**ID transazione sul database */
    public id: string;

    /**Data ed ora di esecuzione */
    public dateTime: Date | string;

    /**Codice operazione */
    public nop: string;

    /**Tipo di transazione */
    public type: TransactionTypeEnum;

    public installationName: string;

    /**ID utente */
    public userId: string;

    /**ID utente che ha eseguito la transazione */
    public executorUserId: string;

    /**ID utente alternativo */
    public userAlternateId: string;

    /**Nome utente */
    public userName: string;

    /**ID canale di vendita */
    public channelId: string;

    /**Totale (Key: valuta, Value: importo) */
    public total: { key: string; value: number }[] = [];

    /**Conti associati (Key: valuta, Value: codice conto) */
    public accounts: { [key: string]: string };

    /**Dettaglio denominazioni */
    public detail: CashDetail[] = [];

    /**Dettaglio categorie nel caso di deposito manuale misto */
    public categoryDetail: TransactionDetail[] = [];

    /**Lista delle destinazioni */
    public destDetails: CashCount;

    /**Dettaglio denominazioni logori */
    public detailUnfit: CashDetail[] = [];

    /**Numero di turno */
    public shiftNumber: string;

    /**Codice cliente associato al dispositivo */
    public customerCode: string;

    /**List of the machine bags that may be involved in the transaction */
    public machineBags: MachineBag[];

    /**Data contabile */
    public accountingDate: Date | string;

    /**Flusso contabile della transazione */
    public flow: TransactionFlowEnum;

    /**Info testuali transazione da caos */
    public info: string;

    /** User Group Name e Id */
    public groupId: number;
    public groupName: string;

    /**Elenco di tutte le valute prensenti nella transazione */
    public currencies: string[] = [];

    /** Integrations Feedback */
    public integrationsFeedbacks: IntegrationFeedback[] = [];

    /** Transaction Ref */
    public transactionRef: string;

    /** user Info */
    public userInfo: string;

    /** user Organization */
    public userOrganization: string;

    /** extra features lette dai plugin */
    public extraFeatures: any;

    public contentBeforeByCurrency: Map<string, number> = new Map<string, number>();
    public contentAfterByCurrency: Map<string, number> = new Map<string, number>();

    /** Lista di ticket */
    public tickets: Ticket[];

    /** Lista di assegni */
    public cheques: Cheque[];

    public banknoteSerialNumberAvailable: boolean;

    public envelopesInfo: TransactionEnvelopeInfo[];

    public subtype: TransactionSubtypeEnum = null;

    parse(obj: any) {
        if (obj.Id != null) this.id = obj.Id;
        if (obj.DateTime) this.dateTime = obj.DateTime;
        if (obj.Nop != null) this.nop = obj.Nop;
        if (obj.Type != null && Object.values(TransactionTypeEnum).includes(obj.Type)) this.type = obj.Type;
        if (obj.InstallationName) this.installationName = obj.InstallationName;
        if (obj.UserId != null) this.userId = obj.UserId;
        if (obj.UserAlternateId != null) this.userAlternateId = obj.UserAlternateId;
        if (obj.UserName != null) this.userName = obj.UserName;
        if (obj.ChannelId != null) this.channelId = obj.ChannelId;

        if (obj.Total != null) {
            // // Debug
            // if (this.installationName == "SDM100-007" && this.nop == "1")
            //     for (let key in obj.Total) {
            //         let valueD = obj.Total[key] + 10;
            //         var tempTotalD = { key: key, value: valueD };
            //         this.total.push(tempTotalD);
            //     }
            // else
            //     //---------
            for (let key in obj.Total) {
                let value = obj.Total[key];
                let tempTotal = { key: key, value: value };
                this.total.push(tempTotal);
            }
        }

        // to do accounts

        if (obj.Detail && obj.Detail.length > 0) {
            obj.Detail.forEach((e) => {
                let m: CashDetail = new CashDetail();
                m.parse(e);
                this.detail.push(m);
            });
        }

        if (obj.CategoryDetail && obj.CategoryDetail.length > 0) {
            obj.CategoryDetail.forEach((e) => {
                let m: TransactionDetail = new TransactionDetail();
                m.parse(e);
                this.categoryDetail.push(m);
            });
        }

        if (obj.DestDetails) {
            this.destDetails = new CashCount();
            this.destDetails.parse(obj.DestDetails);
        }

        if (obj.DetailUnfit && obj.DetailUnfit.length > 0) {
            obj.DetailUnfit.forEach((e) => {
                let m: CashDetail = new CashDetail();
                m.parse(e);
                this.detailUnfit.push(m);
            });
        }

        if (obj.ExtraFeatures != null) this.extraFeatures = obj.ExtraFeatures;
        if (obj.UserOrganization != null) this.userOrganization = obj.UserOrganization;
        if (obj.UserInfo != null) this.userInfo = obj.UserInfo;
        if (obj.TransactionRef != null) this.transactionRef = obj.TransactionRef;
        if (obj.ShiftNumber != null) this.shiftNumber = obj.ShiftNumber;
        if (obj.CustomerCode != null) this.customerCode = obj.CustomerCode;
        if (obj.MachineBags != null)
            obj.MachineBags.forEach((machineBag) => {
                if (this.machineBags == null) this.machineBags = [];
                let machineBagParsed: MachineBag = new MachineBag();
                machineBagParsed.parse(machineBag);
                this.machineBags.push(machineBagParsed);
            });
        if (obj.AccountingDate) this.accountingDate = obj.AccountingDate;
        if (obj.Flow != null && Object.values(TransactionFlowEnum).includes(obj.Flow)) this.flow = obj.Flow;
        if (obj.Info) this.info = obj.Info;
        if (obj.Currencies && obj.Currencies.length > 0) {
            obj.Currencies.forEach((e) => {
                this.currencies.push(e);
            });
        }

        if (obj.ContentBeforeByCurrency) {
            for (let key in obj.ContentBeforeByCurrency) {
                if (key != null && key.length > 0 && (key != "XXX" || (key == "XXX" && obj.ContentBeforeByCurrency[key] > 0)))
                    this.contentBeforeByCurrency.set(key, obj.ContentBeforeByCurrency[key]);
            }
        }

        if (obj.ContentAfterByCurrency) {
            for (let key in obj.ContentAfterByCurrency) {
                if (key != null && key.length > 0 && (key != "XXX" || (key == "XXX" && obj.ContentAfterByCurrency[key] > 0)))
                    this.contentAfterByCurrency.set(key, obj.ContentAfterByCurrency[key]);
            }
        }

        // Integrations Feedback
        if (obj.IntegrationsFeedbacks && obj.IntegrationsFeedbacks.length > 0) {
            obj.IntegrationsFeedbacks.forEach((e) => {
                this.integrationsFeedbacks.push(IntegrationFeedback.parse(e));
            });
        }

        if (obj.GroupId) this.groupId = obj.GroupId;
        if (obj.GroupName) this.groupName = obj.GroupName;
        if (obj.ExecutorUserId) this.executorUserId = obj.ExecutorUserId;

        if (obj.Tickets) {
            this.tickets = new Array<Ticket>();
            obj.Tickets.forEach((ticket) => {
                let t = new Ticket();
                t.parse(ticket);
                this.tickets.push(t);
            });
        }
        if (obj.Cheques) {
            this.cheques = new Array<Cheque>();
            obj.Cheques.forEach((cheque) => {
                let c = new Cheque();
                c.parse(cheque);
                this.cheques.push(c);
            });
        }

        if (obj.BanknoteSerialNumberAvailable) this.banknoteSerialNumberAvailable = obj.BanknoteSerialNumberAvailable;

        if (obj.EnvelopesInfo) {
            this.envelopesInfo = new Array<TransactionEnvelopeInfo>();
            obj.EnvelopesInfo.forEach((envelopeInfo) => {
                let e = new TransactionEnvelopeInfo();
                e.parse(envelopeInfo);
                this.envelopesInfo.push(e);
            });
        }

        if (obj.Subtype != null && obj.Subtype != undefined) this.subtype = obj.Subtype;
    }
}
